import { render, staticRenderFns } from "./TextToInitials.vue?vue&type=template&id=63b7c719&"
import script from "./TextToInitials.vue?vue&type=script&lang=js&"
export * from "./TextToInitials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports